var React = require('react');

function Nodes (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#4A4A4A;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"8,6.2 5.5,4.8 5.5,1.9 8,0.5 10.5,1.9 10.5,4.8 \t","key":0}),React.createElement("polygon",{"className":"st0","points":"13,6.9 15.5,8.3 15.5,11.2 13,12.6 10.5,11.2 10.5,8.3 \t","key":1}),React.createElement("polygon",{"className":"st0","points":"3,6.9 5.5,8.3 5.5,11.2 3,12.6 0.5,11.2 0.5,8.3 \t","key":2}),React.createElement("polygon",{"className":"st0","points":"8,9.8 10.5,11.2 10.5,14.1 8,15.5 5.5,14.1 5.5,11.2 \t","key":3}),React.createElement("line",{"className":"st0","x1":"8","y1":"9.8","x2":"8","y2":"6.2","key":4}),React.createElement("polyline",{"className":"st0","points":"12,7.4 12,6 10.1,5 \t","key":5}),React.createElement("polyline",{"className":"st0","points":"4,7.5 4,6 5.9,5 \t","key":6})])]);
}

Nodes.displayName = "Nodes";

Nodes.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Nodes;

Nodes.default = Nodes;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/nodes.svg
// module id = ../icon/src/icons/nodes.svg
// module chunks = 0